module.exports = __webpack_public_path__ + "img/kapsela.014285ad.png";